import { Card, CardBody, Col, Nav, NavItem, NavLink } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { ContactDetailsHeading } from "../../../../utils/Constant";
import RecentContact from "./RecentContact";

const ContactDetails = () => {
  return (
    <Col xxl="3" md="6" className="box-col-6 proorder-xl-9 proorder-lg-9">
      <Card className="contact-details">
        <CardHeaderCommon title={ContactDetailsHeading} />
        <CardBody className="pt-0">
          <Nav className="simple-wrapper nav-pills d-flex">
            <NavItem>
              <NavLink className="f-w-600" >
                Amount BTC
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="f-w-700" >
                1,3000000
              </NavLink>
            </NavItem>
          </Nav>
          <RecentContact />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ContactDetails;
